import clsx from 'clsx';
import {useState} from 'react';
import PropTypes from 'prop-types';

import {BodyText} from './BodyText';

import {ReactComponent as ChevronDownIcon} from '~/assets/icons/chevron-down.svg';

/**
 * Accordion component
 * Client component that renders an array of WYSIWYG blocks of variable lengths,
 * including mutex expand/contract state
 */

export function Accordion({sanityModule}) {
  const {groups} = sanityModule;

  const [expandedGroups, setExpandedGroups] = useState(
    groups?.map((group) => group.defaultExpanded),
  );

  const onGroupClick = (index) => {
    setExpandedGroups(
      expandedGroups?.map((expanded, i) =>
        i === index ? !expanded : expanded,
      ),
    );
  };

  return (
    <div className="accordion">
      {groups?.map((group, i) => (
        <div className="accordion__group" key={group._key}>
          <div
            className="accordion__title"
            onClick={() => onGroupClick(i)}
            role="presentation"
          >
            <div className="accordion__title-text">{group.title ?? ''}</div>
            <button
              className={clsx(
                'accordion__title-trigger',
                expandedGroups[i] && 'accordion__title-trigger--active',
              )}
              aria-expanded={expandedGroups[i]}
            >
              <ChevronDownIcon />
            </button>
          </div>
          {expandedGroups[i] && group.body && (
            <div className="accordion__body">
              <BodyText sanityModule={group} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

Accordion.propTypes = {
  sanityModule: PropTypes.shape({
    groups: PropTypes.arrayOf(
      PropTypes.shape({
        _key: PropTypes.string.isRequired,
        title: PropTypes.string,
        body: PropTypes.array,
        defaultExpanded: PropTypes.bool,
      }),
    ).isRequired,
  }).isRequired,
};
